import React from "react";
import { FlexContainer, LottieLoadingIndicator, PortalLoadingState } from "src/components";

export const PageLoadingContainer = ({ children, isFetching }) => {

    return (
        <FlexContainer>
            { isFetching && (
                <PortalLoadingState
                    minHeight="40rem"
                    style={{
                        overflowX: "auto",
                        maxWidth: "98.625rem",
                    }}
                >
                    <LottieLoadingIndicator />
                </PortalLoadingState>
            )}
            { !isFetching && children }
        </FlexContainer>
    );
};
